// extracted by mini-css-extract-plugin
export default {"heading":"heading__M2IwM"};